import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  useDisclosure,
} from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';
import OrderApi from 'api/orders';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { OrderStatusOptions, OrderTypeOptions } from 'config/constant';
import OrderItemTable from './components/orderItemTable';
import TransactionTable from './components/transactionTable';
import Card from 'components/card/Card';
import OrderStepper from './components/orderStepper/orderStepper';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { isValidUUID } from 'utils/fetchUtils';
import PageError from 'components/nopermission/PageError';

const Order = () => {
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [forInvoice, setForInvoice] = useState(false);
  const toast = useToast();
  const toastIdRef = React.useRef();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const { getPermissionsForModule } = usePermissions();
  const [ordersPermissions, setOrdersPermissions] = useState(null);
  const [fetchOrderDataError, setFetchOrderDataError] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [email, setEmail] = useState('');
  const [sendInvoiceLoading, setSendInvoiceLoading] = useState(false);


  useEffect(() => {
    const ordersPermissions = getPermissionsForModule([
      Modules.Orders,
      Modules.MakerCheckers,
    ]);
    setOrdersPermissions(ordersPermissions);
  }, []);

  const id = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const GoToCustomerUser = (id) => {
    const url = `/admin/customeruser/${id}`;
    window.open(url, '_blank');
  };

  const FetchOrderData = async () => {
    if (!isValidUUID(id)) {
      setFetchOrderDataError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await OrderApi.List({ orderId: id });
      response = response.data;
      // console.log('response from order', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchOrderDataError(false);
        response?.data?.status === 'COMPLETED' && setForInvoice(true);
        setOrderData(response?.data);
      } else {
        setFetchOrderDataError(true);
        setOrderData({});
      }
    } catch (err) {
      setFetchOrderDataError(true);
      console.log(err);
    }
  };

  useEffect(() => {
    FetchOrderData();
  }, []);

  const FetchInvoice = async () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      setInvoiceLoading(true);
      let response = await OrderApi.GetInvoice(id);
      response = response.data;
      console.log('5response = ', response);
      setInvoiceLoading(false);
      if (response.status_code === 200) {
        window.open(response?.data?.read_url, '_blank');
      } else {
        setInvoiceLoading(false);
        toastIdRef.current = toast({
          title:
            response?.message ||
            'Unable to Generate Invoice, please try again in few moments..',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
      setInvoiceLoading(false);
      toastIdRef.current = toast({
        title: 'Unable to Generate Invoice, please try again in few moments..',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  const SendInvoice = async () => {
    if (!email) {
      toast({
        title: 'Please enter email address',
        status: 'warning',
        duration: 2000,
        isClosable: true,
        position: 'top',
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast({
        title: 'Please enter a valid email address',
        status: 'warning',
        duration: 2000,
        isClosable: true,
        position: 'top',
      });
      return;
    }

    try {
      setSendInvoiceLoading(true);

      let response = await OrderApi.SendInvoice({
        order_id: id,
        email: email,
      });

      response = response.data;
      setSendInvoiceLoading(false);

      if (response.status_code === 200) {
        toast({
          title: 'Invoice sent successfully',
          status: 'success',
          duration: 2000,
          isClosable: true,
          position: 'top',
        });
        setEmail('');
        onClose();
      } else {
        toast({
          title: response?.message || 'Failed to send invoice',
          status: 'error',
          duration: 2000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      setSendInvoiceLoading(false);
      toast({
        title: 'Failed to send invoice',
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'top',
      });
    }
  };


  if (!ordersPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Orders} />;
  }

  return loading ? (
    <Center
      mt='10rem'
      width='100%'
    // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : fetchOrderDataError ? (
    <PageError />
  ) : (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Send Invoice</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Text mb={2}>Enter Email Address</Text>
            <Input
              placeholder="example@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="brand"
              isLoading={sendInvoiceLoading}
              onClick={SendInvoice}
            >
              Send
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Box mt='8rem'>
        <Flex direction='column' gap={8}>
          <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
            <Card display='flex' gap={4}>
              <Flex direction='column' gap={2}>
                <Text fontWeight='medium'>Order by</Text>
                <Button
                  variant='light'
                  onClick={() => {
                    GoToCustomerUser(orderData?.user?.id);
                  }}
                >
                  <Text fontWeight='bold' mr={2}>
                    {orderData?.user?.name}
                  </Text>
                  <MdArrowForward />
                </Button>
              </Flex>

              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>
                  Order Number
                </Text>
                <Text fontWeight='bold'>{orderData?.code}</Text>
              </Flex>

              {
                orderData?.record_number && (
                  <Flex justifyContent='space-between' gap={2}>
                    <Text fontWeight='medium'>
                      Invoice Number
                    </Text>
                    <Text fontWeight='bold'>{orderData?.record_number}</Text>
                  </Flex>
                )
              }


              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Order Type</Text>
                <Text>
                  {
                    OrderTypeOptions.find(
                      (option) => option.value === orderData?.order_type
                    )?.label
                  }
                </Text>
              </Flex>

              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Date of Order</Text>
                <Text>
                  {moment(orderData.created_at).format('DD MMM YY, HH:mm')}
                </Text>
              </Flex>

              <Flex justifyContent='space-between' gap={2}>
                <Text color='brand.500' fontWeight='medium'>
                  Total Amount
                </Text>
                <Text fontWeight='bold'>INR {orderData?.total_amount}</Text>
              </Flex>

              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>
                  Status
                </Text>
                <Text>{
                  OrderStatusOptions.find((option) => option.value === orderData?.status)
                    ?.label
                }</Text>
              </Flex>

              {forInvoice && ordersPermissions?.read && (
                <Flex mt='auto' gap={3} ml='auto'>
                  <Button
                    isLoading={invoiceLoading}
                    variant='outline'
                    onClick={FetchInvoice}
                  >
                    View Invoice
                  </Button>

                  <Button
                    variant='brand'
                    onClick={onOpen}
                  >
                    Send Invoice
                  </Button>
                </Flex>
              )}

            </Card>
            <Card display='flex' gap={8}>
              <Center justifyContent='space-between' gap={2}>
                <Text fontSize='lg' fontWeight='medium'>
                  Order Status
                </Text>
                {/* <Flex
                direction='column'
                align='flex-end'>
                <Text
                  fontSize='lg'
                  fontWeight='bold'
                  color={
                    orderData.status === 'COMPLETED'
                      ? 'green'
                      : orderData.status === 'FAILED'
                        ? 'red'
                        : ''
                  }>
                  {OrderStatusOptions.find(
                    (option) => option.value === orderData?.status
                  )?.label.toUpperCase()}
                </Text>
                <Text color='gray.500'>
                  Last updated:{' '}
                  {moment(orderData.updated_at).format('DD MMM YY, HH:mm')}
                </Text>
              </Flex> */}
              </Center>
              {/* <Divider mt={-2} /> */}
              <OrderStepper
                statusArray={
                  orderData?.order_status && orderData?.order_status.length
                    ? [
                      {
                        status: orderData.status,
                        updated_at: orderData.updated_at,
                      },
                      ...orderData?.order_status,
                    ]
                    : [
                      {
                        status: orderData.status,
                        updated_at: orderData.updated_at,
                      },
                    ]
                }
              />
            </Card>
          </Flex>

          <Flex direction='column' gap={3}>
            {/* <Text fontSize='2xl' fontWeight='500'>
            Order Items
          </Text> */}
            {orderData?.orderitem?.length > 0 ? (
              <OrderItemTable orderItems={orderData?.orderitem} orderData={orderData} />
            ) : (
              <Flex>
                <Text fontWeight='medium'>There are no order items.</Text>
              </Flex>
            )}
          </Flex>
          {orderData?.order_type !== 'CLOSE_SAVING_PLAN' && orderData?.order_type !== 'LOCKER_JEWELLERY_REDEEM' && (
            <Flex mt={2} direction='column' gap={3}>
              <Text fontSize='2xl' fontWeight='500'>
                Transactions
              </Text>
              {orderData?.transaction?.length > 0 ? (
                <TransactionTable
                  propFunct={FetchOrderData}
                  transactions={orderData?.transaction}
                  orderStatus={orderData?.status}
                />
              ) : (
                <Flex>
                  <Text fontWeight='medium'>There are no transactions.</Text>
                </Flex>
              )}
            </Flex>
          )}
        </Flex>
      </Box>

    </>
  );
};

export default Order;
